import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User, getUserDisplayName } from '@core/core.state';
import { TypedDialog } from '@platform/dialog/dialog-v2.service';
import { requireSelection } from '@platform/shared/utilities/require-selection-validator';

export interface ConfirmDialogData {
  titleT: string;
  availableUsers: User[];
}

export interface ConfirmDialogReturn {
  isConfirmed: boolean;
  selectedUser?: User;
}

@Component({
  selector: 'app-user-selection-dialog',
  templateUrl: './user-selection-dialog.component.html',
  styleUrls: ['./user-selection-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSelectionDialogComponent implements TypedDialog<UserSelectionDialogComponent, ConfirmDialogData, ConfirmDialogReturn> {
  public userForm!: UntypedFormGroup;
  public title: string;

  randomName1 = Math.random().toString();

  constructor(
    public dialogRef: MatDialogRef<UserSelectionDialogComponent, ConfirmDialogReturn>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.userForm = this.formBuilder.group({
      user: [null, [Validators.required, requireSelection]],
    });
  }

  private get userControl(): AbstractControl {
    return this.userForm.get('user')!;
  }

  confirm() {
    this.dialogRef.close({ isConfirmed: true, selectedUser: this.userControl.value });
  }

  cancel() {
    this.dialogRef.close({ isConfirmed: false });
  }

  public getUserDisplayName(user: User): string {
    return getUserDisplayName(user);
  }
}
